export default "__VITE_ASSET__EJbry5TD__"